interface Locale {
  default: boolean;
  path: string;
  locale: string;
  dateFormat: string;
  siteLanguage: string;
  ogLanguage: string;
  ogAlternateLanguages: string[];
  defaultTitle: string;
  defaultDescription: string;
}

export const locales: Record<string, Locale> = {
  en: {
    default: false,
    path: `en`,
    locale: `en-US`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en`,
    ogLanguage: `en_US`,
    ogAlternateLanguages: [`de_DE`, `fr_FR`],
    defaultTitle: `AutoCenter Meschede GmbH`,
    defaultDescription: `We have been fulfilling automotive dreams for car maniacs from Germany and all over the world since 2008. Specializing in sports cars and exclusive vehicles of all classes, we are always motivated to offer only the best for our customers.`
  },
  de: {
    default: true,
    path: `de`,
    locale: `de-DE`,
    dateFormat: `DD.MM.YYYY`,
    siteLanguage: `de`,
    ogLanguage: `de_DE`,
    ogAlternateLanguages: [`en_US`, `fr_FR`],
    defaultTitle: `AutoCenter Meschede GmbH`,
    defaultDescription: `Bereits seit 2008 erfüllen wir nun schon automobile Träume für Autoverrückte aus Deutschland und aller Welt. Spezialisiert auf Sportwagen und exklusive Fahrzeuge aller Klassen sind wir stets motiviert, nur das Beste für unsere Kunden zu bieten.`
  },
  fr: {
    default: false,
    path: `fr`,
    locale: `fr-FR`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `fr`,
    ogLanguage: `fr_FR`,
    ogAlternateLanguages: [`de_DE`, `en_US`],
    defaultTitle: `AutoCenter Meschede GmbH`,
    defaultDescription: `Depuis 2008 déjà, nous réalisons les rêves automobiles des fous de voitures d'Allemagne et du monde entier. Spécialisés dans les voitures de sport et les véhicules exclusifs de toutes catégories, nous sommes toujours motivés pour offrir le meilleur à nos clients.`
  }
};
